// Kleiner API-Client fuers Dashboard. Nutzt Cookies (credentials: 'include'),
// das Login-Cookie wird vom Backend gesetzt (siehe backend/src/auth.js).
const BASE = ""; // gleiche Domain (dashboard.darlux-design.de -> selber Container wie api)

async function request(path, options = {}) {
  const res = await fetch(BASE + path, {
    credentials: "include",
    headers: options.body instanceof FormData ? {} : { "content-type": "application/json" },
    ...options,
  });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error((data && data.error) || `Fehler (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  me: () => request("/api/me"),
  login: (username, password) =>
    request("/api/login", { method: "POST", body: JSON.stringify({ username, password }) }),
  logout: () => request("/api/logout", { method: "POST" }),

  requests: () => request("/api/requests"),
  markContacted: (id) => request(`/api/requests/${id}/contacted`, { method: "PATCH" }),
  convertRequest: (id) => request(`/api/requests/${id}/convert`, { method: "PATCH" }),
  cancelRequest: (id) => request(`/api/requests/${id}/cancel`, { method: "PATCH" }),
  setAiReply: (id, aiReply) =>
    request(`/api/requests/${id}/ai-reply`, { method: "PATCH", body: JSON.stringify({ aiReply }) }),

  orders: () => request("/api/orders"),
  createOrder: (payload) => request("/api/orders", { method: "POST", body: JSON.stringify(payload) }),
  updateOrder: (id, payload) => request(`/api/orders/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  doneOrder: (id) => request(`/api/orders/${id}/done`, { method: "PATCH" }),
  cancelOrder: (id) => request(`/api/orders/${id}/cancel`, { method: "PATCH" }),

  list: (resource) => request(`/api/${resource}`),
  createItem: (resource, payload) => request(`/api/${resource}`, { method: "POST", body: JSON.stringify(payload) }),
  updateItem: (resource, id, payload) =>
    request(`/api/${resource}/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  deleteItem: (resource, id) => request(`/api/${resource}/${id}`, { method: "DELETE" }),
};

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch("/api/upload", { method: "POST", credentials: "include", body: fd });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error((data && data.error) || "Upload fehlgeschlagen");
  return data; // { fileName, fileUrl }
}
